import { GlobalService, StorageService } from '@app/services';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({ providedIn: 'root' })
export class JwtHelper {
  decodedToken: any;
  expirationDate: Date;
  helper = new JwtHelperService();
  isExpired: boolean;
  token: string;

  constructor(
    private serviceGlobal: GlobalService,
    private serviceStorage: StorageService
  ) {
    this.token = this.serviceStorage.getAccessToken();
  }

  getDecodedToken() {
    if (!this.token) {
      this.token = this.serviceStorage.getAccessToken();
    }
    if (!this.decodedToken) {
      this.decodedToken = this.helper.decodeToken(this.token);
      this.serviceGlobal.exibirMensagem('Token decodificado');
      this.serviceGlobal.exibirMensagem(JSON.stringify(this.decodedToken));
    }
    return this.decodedToken;
  }

  getExpirationDate() {
    if (!this.token) {
      this.token = this.serviceStorage.getToken();
    }
    if (!this.expirationDate) {
      this.expirationDate = this.helper.getTokenExpirationDate(this.token);
      this.serviceGlobal.exibirMensagem(
        `Data de Expiração: ${this.expirationDate}`
      );
    }
    return this.expirationDate;
  }

  getIsExpired() {
    if (!this.token) {
      this.token = this.serviceStorage.getToken();
    }
    if (!this.isExpired) {
      this.isExpired = this.helper.isTokenExpired(this.token);
      this.serviceGlobal.exibirMensagem(`Token Expirado? ${this.isExpired}`);
    }
    return this.isExpired;
  }
}
